/* The drawer adds its open class inside requestAnimationFrame, which Chrome
   throttles in background tabs — the panel then stays off-screen while the
   drawer counts as open. Watch only for the `hidden` attribute being removed
   and force the class on, after a reflow so the transition still runs.
   Closing is untouched: it re-adds `hidden`, and we do nothing then. */
(function () {
  function start() {
    var d = document.querySelector('[data-fh-cart]');
    if (!d) return setTimeout(start, 300);
    function open() {
      if (d.hasAttribute('hidden')) return;
      void d.offsetWidth;
      d.classList.add('is-open');
    }
    new MutationObserver(open).observe(d, { attributes: true, attributeFilter: ['hidden'] });
    open();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();